"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationControls = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../ButtonTertiary/index.js");
var _index2 = require("../Icon/icons/IconChevronLeft/index.js");
var _index3 = require("../Icon/icons/IconChevronRight/index.js");
var _Container = require("./Container.js");
var _Label = require("./Label.js");
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["onIncrement", "onDecrement", "children", "backButtonAriaLabel", "forwardButtonAriaLabel", "aria-label", "id"];
/**
 * PaginationControls navigate between pages of data, by showing left and right chevron buttons for paging backward or forward through data,
 * with the option for descriptive text shown inline.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-pagination-paginationcontrols--docs) |
 * [Encore site](https://encore.spotify.net/web/components/pagination#pagination-controls) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PaginationControls) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12486&t=10cChvdYyvmld0PS-1)
 */
var PaginationControls = exports.PaginationControls = function PaginationControls(_ref) {
  var onIncrement = _ref.onIncrement,
    onDecrement = _ref.onDecrement,
    children = _ref.children,
    _ref$backButtonAriaLa = _ref.backButtonAriaLabel,
    backButtonAriaLabel = _ref$backButtonAriaLa === void 0 ? 'Back' : _ref$backButtonAriaLa,
    _ref$forwardButtonAri = _ref.forwardButtonAriaLabel,
    forwardButtonAriaLabel = _ref$forwardButtonAri === void 0 ? 'Forward' : _ref$forwardButtonAri,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Pages' : _ref$ariaLabel,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'page-nums' : _ref$id,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    "aria-label": ariaLabel,
    "aria-describedby": id
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.PaginationControls
  }), children && /*#__PURE__*/_react["default"].createElement(_Label.Label, {
    id: id,
    "aria-hidden": "true",
    className: (0, _layoutTheme.textClass)('bodySmall')
  }, children), /*#__PURE__*/_react["default"].createElement(_index.ButtonTertiary, {
    "aria-label": backButtonAriaLabel,
    onClick: onDecrement,
    disabled: typeof onDecrement === 'undefined',
    iconOnly: _index2.IconChevronLeft,
    size: "small",
    condensedAll: true,
    type: "button"
  }), /*#__PURE__*/_react["default"].createElement(_index.ButtonTertiary, {
    "aria-label": forwardButtonAriaLabel,
    onClick: onIncrement,
    disabled: typeof onIncrement === 'undefined',
    iconOnly: _index3.IconChevronRight,
    size: "small",
    condensedAll: true,
    type: "button"
  }));
};